import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel, WashBasinModel, AssemblyAccessoriesModel } from 'franke-trough-dependencies';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, Button } from 'reactstrap';
import { requestAPIActions } from 'loopback-react-request';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Assemblies.messages';

export interface ConsolesOverlapChoiceProps {
  plateBuilder: GlobalPrivateState['plateBuilder'];
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  id: string;
}

export interface ConsolesOverlapChoiceState {
  tooltipOpen: boolean;
  ignorableTrigger: boolean;
  selectedDecision: 'return' | 'continue' | 'change' | null;
}

export class ConsolesOverlapChoicePartial extends React.Component<ConsolesOverlapChoiceProps, ConsolesOverlapChoiceState> {
  constructor(props: ConsolesOverlapChoiceProps) {
    super(props);

    this.state = {
      tooltipOpen: false,
      ignorableTrigger: false,
      selectedDecision: null
    };
    this.toggle = this.toggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public render() {
    const hasOverlappingError = this.props.plateBuilder && this.props.plateBuilder.calc.hasOverlappingError();
    const hasMiranitConsoles = (this.assemblyAccessories && this.assemblyAccessories.console || this.props.configuration.result && this.props.configuration.result.defaults.assemblyAccessories.console.default) === 'miranit';
    const acceptedMiranitOverlap = this.assemblyAccessories && this.assemblyAccessories.acceptedMiranitOverlap;
    const showWarning = (hasOverlappingError && hasMiranitConsoles && !acceptedMiranitOverlap);
    // console.log('hasOverlappingError', hasOverlappingError, 'acceptedMiranitOverlap', acceptedMiranitOverlap);

    // I think plateBuilder is slowing things down... should confirm
    // If it is, then that means I have to save the "hasOverlappingError" somewhere... perhaps after the dispatch (ideal) if not then from the API... then I can use that everywhere for disabling/warning
    // Ah, no the slow down seems to only happens when the overlap is caused on left side (after positioning troughs)... so its not because of this warning

    const tollTipId = `plate_dimensions_required_tooltip_${this.props.id}`;

    if (!showWarning) { return null }

    return <div className="decision-wrapper warnings-wrapper">
      <span className="info-icon" id={tollTipId}>
        <FontAwesomeIcon icon={faInfo} />
        <Tooltip 
          autohide={false}
          isOpen={this.state.tooltipOpen} 
          placement="top"
          toggle={this.toggle}
          target={tollTipId}
          className="tooltip-choice"
        >
          <p>
            <FormattedMessage {...MESSAGES.consolesOverlapChoiceMessage}/>
          </p>
          <>
            <label>
              <input
                type="radio"
                name="decision"
                value="return"
                checked={this.state.selectedDecision === 'return'}
                onClick={() => this.setState({ignorableTrigger: true})}
                onChange={(ev: React.SyntheticEvent<HTMLInputElement>) => this.handleChange(ev)}
              />
              <FormattedMessage {...MESSAGES.consolesOverlapChoiceContinue}/>
            </label>
            <label>
              <input
                type="radio"
                name="decision"
                value="change"
                checked={this.state.selectedDecision === 'change'}
                onClick={() => this.setState({ignorableTrigger: true})}
                onChange={(ev: React.SyntheticEvent<HTMLInputElement>) => this.handleChange(ev)}
              />
              <FormattedMessage {...MESSAGES.consolesOverlapChoiceChange}/>
            </label>
          </>
          <p className="text-right">
            <Button 
              onClick={(ev: React.MouseEvent<HTMLButtonElement>) => this.handleSubmit(ev, 'submit')}
              className="yes"
              disabled={this.state.selectedDecision === null}
            >
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </p>
        </Tooltip>
      </span>
    </div>
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>): void {
    const { value } = event.target as HTMLInputElement;

    this.setState({
      selectedDecision: value as any
    });
  }

  private dispatchConfiguration() {
    let configuration = this.props.configuration && this.props.configuration.result;
    if (!configuration) { return; }

    if (!configuration.assemblyAccessories) {
      configuration.assemblyAccessories = {
        console: configuration.defaults.assemblyAccessories.console.default,
        selection: configuration.defaults.assemblyAccessories.selection.default,
        acceptedMiranitOverlap: configuration.defaults.assemblyAccessories.acceptedMiranitOverlap.default
      };
    }

    if (this.state.selectedDecision === 'change') {
      configuration.assemblyAccessories.console = 'stainlessSteel';
    }

    if (this.state.selectedDecision === 'return') {
      configuration = {
        ...configuration,
        ...configuration.prev
      };
    }

    if (configuration && this.state.selectedDecision === 'continue') {
      configuration.assemblyAccessories.acceptedMiranitOverlap = true;
    }

    // If I have to, I could also make submission to a new value I guess, with like "acceptOverlappingErrors"... which would basically just ignore all overlapping errors for the remainder of the config

    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${configuration && configuration.id}`,
        options: {
          method: 'PATCH',
          data: configuration
        },
      },
      true,
    ));
  }

  private handleSubmit(event: React.MouseEvent<HTMLButtonElement>, type: 'submit') {
    this.dispatchConfiguration();
  }

  private toggle() {
    if (this.state.ignorableTrigger) {
      this.setState({
        ignorableTrigger: false
      });
    } else {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }
 
  private get assemblyAccessories(): AssemblyAccessoriesModel | undefined {
    const {
      configuration,
    } = this.props;

    return configuration && 
      configuration.result && 
      configuration.result.assemblyAccessories ? 
        configuration.result.assemblyAccessories : undefined;
  }
}

export const ConsolesOverlapChoice = connect((state: GlobalPrivateState) => ({
  plateBuilder: state.plateBuilder,
  configuration: state.configuration,
}))(ConsolesOverlapChoicePartial);

export default ConsolesOverlapChoice;


